import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  BaseServiceFacade,
  GenericApiCall,
} from '../../../../common/store/types';
import { AppState } from '../../types';
import { ListItem } from '../../typeahead/types';
import {
  AttendanceRegularityQueryModel,
  AttendanceRegularityModel,
  AttendanceUsersQueryModel,
} from './types';
import { userWorkAttendanceActions } from './user-work-attendance.actions';
import { userWorkAttendanceSelectors } from './user-work-attendance.selector';

@Injectable()
export class UserWorkAttendanceService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getRegularity: GenericApiCall<
    AttendanceRegularityModel,
    AttendanceRegularityQueryModel
  > = this.genericApiCall(
    userWorkAttendanceActions.getRegularity,
    userWorkAttendanceSelectors.getRegularity,
    true,
  );

  getUsers: GenericApiCall<ListItem[], AttendanceUsersQueryModel> =
    this.genericApiCall(
      userWorkAttendanceActions.getUsers,
      userWorkAttendanceSelectors.getUsers,
      true,
    );

  getSalesPersonRegularity: GenericApiCall<
    AttendanceRegularityModel,
    AttendanceRegularityQueryModel
  > = this.genericApiCall(
    userWorkAttendanceActions.getSalesPersonRegularity,
    userWorkAttendanceSelectors.getSalesPersonRegularity,
    true,
  );

  getSalesPersonUsers: GenericApiCall<ListItem[], AttendanceUsersQueryModel> =
    this.genericApiCall(
      userWorkAttendanceActions.getSalesPersonUsers,
      userWorkAttendanceSelectors.getSalesPersonUsers,
      true,
    );
}
